/**
 * @param {number} num - pads integer with leading zero
 * @returns {string} - integer with padding as string
 */
export const padTimeInteger = (num: number): string => num.toString().padStart(2, '0');
